import React from 'react';
// import styles from '@app/modules/projects/outputs/opm-summary-waterfall/opm-summary-waterfall-erf.module.scss';

interface SubSectionHeaderProps {
  titleColSpan: number;
  title: string;
  className: string;
}

export const SubSectionHeader: React.FC<SubSectionHeaderProps> = ({
  titleColSpan,
  title,
  className,
}) => (
  <tr>
    <th className={className} colSpan={titleColSpan}>
      {title}
    </th>
  </tr>
);
